// extracted by mini-css-extract-plugin
export default {"main":"FormUrlInput_main__TYQLy","label":"FormUrlInput_label__aO+8f"};